import { Navigate } from "react-router-dom";
// Routes for the discover side of the web app (events, shop, Yasmin chat, Stage read pages).
// Merge into App.js: {DISCOVER_ROUTES.map(r => <Route key={r.path} path={r.path} element={r.protected ? <ProtectedRoute>{r.element}</ProtectedRoute> : r.element} />)}
import React from "react";
import Events from "@/pages/events/Events";
import EventDetail from "@/pages/events/EventDetail";
import OrderReturn from "@/pages/events/OrderReturn";
import { WalletReturn, PaymentSuccess, PaymentCancel, PromoteReturn, MealPlansReturn, DbsReturn, GroupReturn, CourseReturn, PulseRedirect, LiveWatch, PlusCode, SharedPlan, CreatorsLeaderboard } from "@/pages/WebReturns";
import { ALIASES, Alias, CompanyPage, LicencesPage, SitemapPage } from "@/pages/site/Aliases";
import { StageNews, StageSports, SoundPage, TeamPage, PlayerPage, LeaguePage } from "@/pages/stage/NewsSports";
import { MeetAgents } from "@/components/agents/Agents";
import AgentProfile from "@/pages/agents/AgentProfile";
import { VerifiedPlus, Membership, Studio, Family, FamilyApproval } from "@/pages/plus/WebOnly";
import Shop, { ShopSaved } from "@/pages/shop/Shop";
import ProductDetail from "@/pages/shop/ProductDetail";
import { Store, Orders } from "@/pages/shop/StoreAndOrders";
import YasminChat from "@/pages/yasmin/YasminChat";
import Reels from "@/pages/stage/Reels";
import Live from "@/pages/stage/Live";
import { Circles, CircleDetail } from "@/pages/stage/Circles";
import { CircleManage } from "@/pages/stage/CircleManage";
import { CollabEditor } from "@/pages/stage/CollabEditor";
import { Collabs, CollabDetail } from "@/pages/stage/Collabs";
import HelpCentre from "@/pages/site/HelpCentre";
import { FoodOrderTracker } from "@/pages/partner/FoodOrders";
import Stories from "@/pages/stage/Stories";
import { HostEvents, NewEvent, ManageEvent } from "@/pages/events/HostEvents";
import { ForgotPassword, SecureAccount, VerifyEmail } from "@/pages/account/AuthLinks";
import Explore, { SharedTrip } from "@/pages/discover/Explore";
import { PulseTag, CircleInvite } from "@/pages/stage/Social";
import { JoinEventTeam, SafetyGuidelines } from "@/pages/site/More";

export const DISCOVER_ROUTES = [
  { path: "/explore", element: <Explore /> },
  { path: "/events/join-team", element: <JoinEventTeam /> },
  { path: "/guidelines", element: <SafetyGuidelines /> },
  { path: "/stage/tag/:tag", element: <PulseTag /> },
  { path: "/circles/invite/:code", element: <CircleInvite /> },
  { path: "/business/enterprise", element: <Navigate to="/ops/pricing" replace /> },
  { path: "/forgot-password", element: <ForgotPassword /> },
  { path: "/secure-account", element: <SecureAccount /> },
  { path: "/verify-email", element: <VerifyEmail /> },
  { path: "/events", element: <Events /> },
  { path: "/events/host", element: <HostEvents />, protected: true },
  { path: "/events/host/new", element: <NewEvent />, protected: true },
  { path: "/events/host/:id", element: <ManageEvent />, protected: true },
  { path: "/help", element: <HelpCentre /> },
  { path: "/food-orders/:id", element: <FoodOrderTracker />, protected: true },
  { path: "/stories", element: <Stories />, protected: true },
  { path: "/stories/:userId", element: <Stories />, protected: true },
  { path: "/events/order-return", element: <OrderReturn />, protected: true },
  { path: "/events/:id", element: <EventDetail /> },
  { path: "/shop", element: <Shop /> },
  { path: "/shop/orders", element: <Orders />, protected: true },
  { path: "/shop/saved", element: <ShopSaved />, protected: true },
  { path: "/wallet-return", element: <WalletReturn /> },
  { path: "/payment/success", element: <PaymentSuccess /> },
  { path: "/payment/cancel", element: <PaymentCancel /> },
  { path: "/promote-return", element: <PromoteReturn /> },
  { path: "/meal-plans/return", element: <MealPlansReturn /> },
  { path: "/provider/dbs", element: <DbsReturn /> },
  { path: "/groups/:id", element: <GroupReturn /> },
  { path: "/communities/:id/course/:courseId", element: <CourseReturn /> },
  { path: "/pulse/:id", element: <PulseRedirect /> },
  { path: "/live/:id", element: <LiveWatch /> },
  { path: "/p/:code", element: <PlusCode /> },
  { path: "/trips/plan-shared/:token", element: <SharedPlan /> },
  { path: "/leaderboards/creators", element: <CreatorsLeaderboard /> },
  { path: "/plus/verified", element: <VerifiedPlus /> },
  { path: "/membership", element: <Membership /> },
  { path: "/studio", element: <Studio /> },
  { path: "/family", element: <Family />, protected: true },
  { path: "/family/approval/:id", element: <FamilyApproval />, protected: true },
  { path: "/agents", element: <MeetAgents /> },
  { path: "/agents/:key", element: <AgentProfile /> },
  { path: "/stage/news", element: <StageNews /> },
  { path: "/stage/sports", element: <StageSports /> },
  { path: "/stage/sports/team/:key", element: <TeamPage /> },
  { path: "/stage/sports/player/:name", element: <PlayerPage /> },
  { path: "/stage/sports/league/:id", element: <LeaguePage /> },
  { path: "/sounds/:id", element: <SoundPage /> },
  { path: "/legal/company", element: <CompanyPage /> },
  { path: "/legal/licences", element: <LicencesPage /> },
  { path: "/about/sitemap", element: <SitemapPage /> },
  { path: "/sitemap", element: <SitemapPage /> },
  ...ALIASES.map(([path, to]) => ({ path, element: <Alias to={to} /> })),
  { path: "/shop/store/:sellerId", element: <Store /> },
  { path: "/shop/:id", element: <ProductDetail /> },
  { path: "/yasmin/chat", element: <YasminChat />, protected: true },
  { path: "/plus/yasmin", element: <YasminChat />, protected: true }, // Stripe return URL from /yasmin/checkout
  { path: "/stage/reels", element: <Reels /> },
  { path: "/stage/live", element: <Live /> },
  { path: "/circles", element: <Circles /> },
  { path: "/circles/:id", element: <CircleDetail /> },
  { path: "/circles/:id/manage", element: <CircleManage /> },
  { path: "/communities/:id", element: <CircleDetail /> }, // paid-join Stripe return URL from the backend
  { path: "/collabs", element: <Collabs /> },
  { path: "/collabs/new", element: <CollabEditor /> },
  { path: "/collabs/:id/edit", element: <CollabEditor /> },
  { path: "/collabs/:id", element: <CollabDetail /> },
];
